export function ChatFromPersonFilter(container) {
    return import(
        /* webpackChunkName: "adminbau-chat" */
        /* webpackMode: "lazy" */
        './chatFromPersonList/ChatFromPersonList.js')
        .then(({default: ChatFromPersonList}) => {
            ChatFromPersonList.init(container);
        })
        .catch((error) => {
            console.log('ChatPersonList loading error', error);
            // alert('Errore di caricamento della pagina. Premi CTRL+F5. Se il problema persiste, contatta admin@ucis.org');
        });

}

export function NewMessage(container) {
    return import(
        /* webpackChunkName: "adminbau-chat" */
        /* webpackMode: "lazy" */
        './newMessage/sendMessage.js')
        .then(({default: SendMessage}) => {
            SendMessage.init(container, '.send-trigger');
        })
        .catch((error) => {
            console.log('loadNewMessage loading error', error);
            // alert('Errore di caricamento della pagina. Premi CTRL+F5. Se il problema persiste, contatta admin@ucis.org');
        });

}

export function Sos() {
    return import(
        /* webpackChunkName: "adminbau-vue" */
        /* webpackMode: "lazy" */
        '../sos/Sos.js')
        .then(({default: Sos}) => {
            Sos.init();
        })
        .catch((error) => {
            console.log('vue sos loading error', error);
            // alert('Errore di caricamento della pagina. Premi CTRL+F5. Se il problema persiste, contatta admin@ucis.org');
        });
}

export function Activity(els) {
    return import(
        /* webpackChunkName: "adminbau-activity" */
        /* webpackMode: "lazy" */
        '../activity/Activity.js'
        )
        .then(({default: Activity}) => {
            // console.log('Activiy chunk loaded:', els);

            for (let el of els) {
                let app = el.getAttribute('data-app');
                switch(app) {
                    case 'edit-partecipants':
                        Activity.editPartecipants(el);
                        break;
                    case 'person-statistics':
                        Activity.personStatistics(el);
                        break;
                    case 'group-statistics':
                        Activity.groupStatistics(el);
                        break;
                }
            }
        })
        .catch((error) => {
            console.log('ActivityJS loading error', error);
        });
}
